import {
	Box,
	Button,
	Card,
	CardBody,
	Divider,
	Flex,
	HStack,
	Heading,
	Image,
	Text
} from "@chakra-ui/react";
import "@fontsource/roboto";
import { AiOutlineStar } from 'react-icons/ai';
import { AiFillStar } from "react-icons/ai";
import { BiTimeFive } from 'react-icons/bi';
import Countdown from "react-countdown";
import { useNavigate } from 'react-router-dom';
import { PiGlobeBold } from 'react-icons/pi';



const RedSwanCard = (props) => {
	let navigate = useNavigate();
	// console.log("in props", props.data)

	const points = new Array(4).fill('1');

	return (
		<Card borderRadius='24px' border='2px solid #F0F0F0'>
			<CardBody padding='0px'>
				<Box w="100%" borderRadius="24px" fontFamily="Roboto" color="#1C3E64" >
					<Image
						borderTopRadius="24px"
						w="100%"
						height="230px"
						src={props.data.images[0]}
						objectFit="fill"
						alt="Image"
					/>
					<Box w="100%" bgColor="white" borderRadius="24px" p="18px">
						<Flex justifyContent='space-between' alignItems='center'>
							<Box w='100%'>
								<Heading color="#1D1B20" fontFamily="Roboto" fontSize="18px" fontWeight="400">{props.data.name}</Heading>
								<Text fontFamily="Roboto" fontSize="14px">{props.data.address}</Text>
							</Box>
							<HStack w="12%" justifyContent="right" cursor='pointer'>
								{props.favoriteProperties.some((obj) => obj.id === props.data.id) ? (
									<AiFillStar
										fontSize="24px"
										color="#1D1B20"
										onClick={(e) => {
											props.handleRemoveFavoriteProperty(e, props.data.id);
										}}
									/>
								) : (
									<AiOutlineStar
										fontSize="24px"
										color="#1D1B20"
										onClick={(e) => {
											props.handleAddFavoriteProperty(e, props.data.id);
										}}
									/>
								)}
							</HStack>
						</Flex>
						<Divider
							orientation="horizontal"
							my='20px'
							color='rgba(28, 62, 100, 0.50)'
							borderWidth='1px'
							variant='solid'
						/>
						<Box>


							<Flex justifyContent='space-between' my='5px'>
								<Box w='70%'>
									<Text fontFamily="Roboto" fontSize="14px">Targeted Investor IRR</Text>
								</Box>
								<Box textAlign="right">
									<Text fontFamily="Roboto" fontSize="14px">{props.data.performanceMetrics?.targetedInvestorIRR ? `${props.data.performanceMetrics?.targetedInvestorIRR}%` : "_"}</Text>
								</Box>
							</Flex>
							<Flex justifyContent='space-between' my='5px'>
								<Box w='70%'>
									<Text fontFamily="Roboto" fontSize="14px">Targeted Average Cash Yield</Text>
								</Box>
								<Box textAlign="right">
									<Text fontFamily="Roboto" fontSize="14px">{props.data.performanceMetrics?.targetedInvestorIRR ? `${props.data.performanceMetrics?.targetedAverageCashYield}%` : "_"}</Text>
								</Box>
							</Flex>
							<Flex justifyContent='space-between' my='5px'>
								<Box w='70%'>
									<Text fontFamily="Roboto" fontSize="14px">Targeted Equity Multiple</Text>
								</Box>
								<Box textAlign="right">
									<Text fontFamily="Roboto" fontSize="14px">{props.data.performanceMetrics?.targetEquity ? `${props.data.performanceMetrics?.targetEquity}x` : "_"}</Text>
								</Box>

							</Flex>
							<Flex justifyContent='space-between' my='5px'>
								<Box w='70%'>
									<Text fontFamily="Roboto" fontSize="14px">Minimum Investment</Text>
								</Box>
								<Box textAlign="right">
									<Text fontFamily="Roboto" fontSize="14px">{props.data.minimumInvestment ? `$${props.data.minimumInvestment}` : "_"}</Text>
								</Box>

							</Flex>

						</Box>
						<Divider
							orientation="horizontal"
							my='20px'
							color='rgba(28, 62, 100, 0.50)'
							borderWidth='1px'
							variant='solid'
						/>
						<HStack>
							<HStack w="50%" >
								<PiGlobeBold fontSize="14px" />
								<Text fontFamily="Roboto" fontSize="14px">Risk : {props.data.riskLevel ? `${props.data.riskLevel}` : " _"}</Text>
							</HStack>
							<HStack w="50%" justifyContent="flex-end">
								<BiTimeFive fontSize="14px" />
								<Text fontFamily="Roboto" fontSize="14px" float="right">
									{
										props.data.performanceMetrics?.closingDate ?
											<Countdown
												date={new Date(props.data.performanceMetrics?.closingDate)}
												renderer={({ days, hours, minutes, seconds }) => {
													const formattedHours = hours
														.toString()
														.padStart(2, "0");
													const formattedMinutes = minutes
														.toString()
														.padStart(2, "0");
													const formattedSeconds = seconds
														.toString()
														.padStart(2, "0");
													const countdownDisplay = `${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
													if (days == 0) {
														return (
															<span>
																Time Left {countdownDisplay}
															</span>
														);
													} else {
														return (
															<span>
																{days} Days Left
															</span>
														);
													}
												}}
											/>
											:
											null

									}

								</Text>
							</HStack>
						</HStack>
						<HStack justifyContent="right" mt='20px'>
							<Button  _hover={{bgColor:"transparent",color:"#002B5B"}} border="1px solid #002B5B" color="#F0F0F0" fontFamily="Roboto" p="20px 48px" bgColor="#002B5B" borderRadius="200px" fontSize="14px" onClick={() => navigate(`/property/${props.data.id}`)}>See Details</Button>
						</HStack>
					</Box>
				</Box>
			</CardBody>
		</Card>
	);
}

export default RedSwanCard;